import { Check2 } from "react-bootstrap-icons";

//App
import useIconStyles from "./styles";
import { IconProps } from "../../../types";

const ActivateIcon = (props: IconProps) => {
  const { iconText = "Activate", pendingText = "" } = props;
  const iconStyles = useIconStyles();
  return (
    <div style={iconStyles.flex}>
      <Check2 style={iconStyles.viewIcon} size={20} />
      <div>
        {iconText} {pendingText}
      </div>
    </div>
  );
};

export default ActivateIcon;
